/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "@fontsource/roboto";
import { TDocumentDefinitions } from 'pdfmake/interfaces';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function gerarOpcoesApresentacao(apresentacao: any): string[] {
    const opcoes = {
        a: 'Comprimidos/cápsulas orais',
        b: 'Suspensão, xaropes',
        c: 'Injecção',
        d: 'Diluente',
        e: 'Pó para reconstituição da suspensão',
        f: 'Pó para reconstituição de injectáveis',
        g: 'Gotas oftálmicas',
        h: 'Gotas nasais',
        i: 'Gotas auriculares',
        j: 'Nebulizadores',
        k: 'Creme, pomadas, pastas, linimentos'
    };

    const marcadas = Object.entries(opcoes)
        .filter(([key]) => apresentacao?.[key] === true)
        .map(([, label]) => label);

    if (apresentacao?.outros) {
        marcadas.push(`outros: ${apresentacao.outros}`);
    }

    return marcadas;
}

const FichaNotificacaoReacoesAdversas = async (dados?: any) => {
    const imageBlob = await fetch('/img/logo/InsigniaAngola.png').then(res => res.blob());
    const imageBase64 = await getBase64Image(imageBlob) as string;

    const limitarTexto = (texto: string, maxCaracteres: number): string => {
        if (!texto) return '';
        return texto.length > maxCaracteres
            ? texto.substring(0, maxCaracteres) + '...'
            : texto;
    };

    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [25, 25, 25, 25],
        content: [
            // Cabeçalho
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        image: imageBase64,
                                        width: 40,
                                        alignment: 'center',
                                        margin: [0, 3, 0, 3]
                                    },
                                    {
                                        text: 'MINISTÉRIO DA SAÚDE',
                                        alignment: 'center',
                                        bold: true,
                                        fontSize: 10
                                    },
                                    {
                                        text: 'AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIA DE SAÚDE',
                                        alignment: 'center',
                                        fontSize: 8
                                    },
                                    {
                                        text: 'DEPARTAMENTO DE FARMACOVIGILÂNCIA, TECNOVIGILÂNCIA E ENSAIOS CLÍNICOS.',
                                        alignment: 'center',
                                        fontSize: 8
                                    }
                                ],
                                margin: [5, 5, 5, 5]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'FICHA DE NOTIFICAÇÃO DE SUSPEITA DE REACÇÕES ADVERSAS A MEDICAMENTOS E PRODUTOS SANITÁRIOS', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#97BF04',
                                margin: [0, 2, 0, 2]
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 3]
            },

            // Unidade Sanitária, Serviço, Localidade
            {
                table: {
                    widths: ['33%', '33%', '34%'],
                    body: [
                        [
                            { text: 'UNIDADE SANITÁRIA', fontSize: 8, bold: true, alignment: 'center', border: [false, false, false, false] },
                            { text: 'SERVIÇO', fontSize: 8, bold: true, alignment: 'center', border: [false, false, false, false] },
                            { text: 'LOCALIDADE', fontSize: 8, bold: true, alignment: 'center', border: [false, false, false, false] }
                        ],
                        [
                            { text: `${dados?.unidadeSanitaria?.nome ?? ''}`, fontSize: 8, margin: [0, 3, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.servico ?? ''}`, fontSize: 8, margin: [0, 3, 0, 0] },
                            { text: `${dados?.unidadeSanitaria?.municipio ?? ''}`, fontSize: 8, margin: [0, 3, 0, 0] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Checkboxes Informação Inicial/Complementar
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            //inicialmente está marcado só o Informação Inicial por default
                            { text: '[ X ] Informação Inicial', fontSize: 8, margin: [0, 3, 0, 2], border: [false, false, false, false] },
                            { text: '[ ] Informação Complementar', fontSize: 8, margin: [5, 3, 0, 2], alignment: 'right', border: [false, false, false, false] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 3]
            },

            // PACIENTE
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'PACIENTE', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#97BF04',
                                margin: [0, 2, 0, 2],
                                italics: true,
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            // Dados do Paciente - Linha 1
            {
                table: {
                    widths: ['*', 60, 40, 50, 60],
                    body: [
                        [
                            { text: 'Nome e Apelido', fontSize: 8, bold: true },
                            { text: 'Idade', fontSize: 8, bold: true, alignment: 'center' },
                            { text: 'Sexo', fontSize: 8, bold: true, alignment: 'center' },
                            { text: 'Peso (Kg)', fontSize: 8, bold: true, alignment: 'center' },
                            { text: 'Altura (cm)', fontSize: 8, bold: true, alignment: 'center' }
                        ],
                        [
                            { text: `${dados?.paciente?.nome}`, margin: [0, 2, 0, 0], fontSize: 8, border: [true, false, false, false] },
                            { text: `${dados?.paciente?.idade}`, margin: [0, 2, 0, 0], fontSize: 8, border: [true, false, false, false] },
                            { text: `${dados?.paciente?.sexo === "M" ? 'Masculino' : 'Femenino'}`, margin: [0, 2, 0, 0], fontSize: 8, border: [true, false, false, false] },
                            { text: `${dados?.paciente?.peso}`, margin: [0, 2, 0, 0], fontSize: 8, border: [true, false, false, false] },
                            { text: `${dados?.paciente?.altura}`, margin: [0, 2, 0, 0], fontSize: 8, border: [true, false, true, false] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Gestante e Antecedentes
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `Gestante: [ ${dados?.paciente?.gestante === true ? 'X' : ''} ]Sim [ ${dados?.paciente?.gestante === false ? 'X' : ''} ]Não`,
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [true, true, false, false]
                            },
                            {
                                text: `Raça: [ ${dados?.paciente.raca === 'Negro' ? 'X' : ''} ]Negra [ ${dados?.paciente.raca === 'Branco' ? 'X' : ''} ]Branca [ ${dados?.paciente.raca === 'Outro' ? 'X' : ''} ]Outras`,
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [false, true, true, false]
                            },
                        ],
                        [
                            {
                                text: `Antecedentes:  [ ${dados?.paciente?.antecendentes?.medicosSP === true ? 'X' : ''}  ]Médicos, serológicos, psiquiátrico`,
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [true, false, false, false]
                            },
                            {
                                text: `[ ${dados?.paciente?.antecendentes?.cirurgicos === true ? 'X' : ''} ]Cirúrgicos    [ ${dados?.paciente?.antecendentes?.abusoDependencia === true ? 'X' : ''} ]De abuso ou de dependência`,
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [false, false, true, false]
                            },

                        ],
                        [
                            {
                                text: '[ ]Reacções anteriores ao medicamento ou outros',
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [true, false, false, false]
                            },
                            {
                                text: `[ ${dados?.paciente?.antecendentes?.cirurgicos === true ? 'X' : ''} ]Alergias conhecidas`,
                                fontSize: 8,
                                margin: [3, 2, 0, 2],
                                border: [false, false, true, false]
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: '', fontSize: 8, border: [true, false, true, false], margin: [0, 4, 0, 0] }],
                        [{ text: `Endereço: ${dados?.paciente.municipio}-${dados?.paciente.bairro}     Telefone: ${dados?.paciente.telefone}      E-mail: ${dados?.paciente.email}`, fontSize: 8, border: [true, false, true, true] }]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // MEDICAMENTO(S)
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'MEDICAMENTO (S)', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#97BF04',
                                margin: [0, 2, 0, 2],
                                italics: true,
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            // Tabela de Medicamentos
            {
                table: {
                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    body: [
                        [
                            { text: 'Nome Comercial/DCI', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Apresentação', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Dose diária', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Via e hora de adm.', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Data da Toma', fontSize: 7, bold: true, alignment: 'center', colSpan: 2 },
                            {},
                            { text: 'Motivo de Tratament', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'No.Lote', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Data Caduc', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 },
                            { text: 'Local de Compra', fontSize: 7, bold: true, alignment: 'center', rowSpan: 2 }
                        ],
                        [
                            {},
                            {},
                            {},
                            {},
                            { text: 'Início', fontSize: 7, bold: true, alignment: 'center' },
                            { text: 'Término', fontSize: 7, bold: true, alignment: 'center' },
                            {},
                            {},
                            {},
                            {}
                        ],
                        ...dados?.identificacaoProducto.map((medicamento: any) => [
                            { text: `${medicamento?.nomeDCI ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            {
                                text: gerarOpcoesApresentacao(dados?.identificacaoProducto[0]?.apresentacaoProducto).join(', '),
                                margin: [0, 3, 0, 0], fontSize: 7, alignment: 'left'
                            },
                            { text: `${medicamento?.doseDiaria ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            { text: `${medicamento?.viaLocalAdmin ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            { text: `${new Date(medicamento?.InicioDataToma).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            { text: `${new Date(medicamento?.terminoDataToma).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            { text: `${medicamento?.motivoTratamento ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8 },
                            { text: `${medicamento?.numeroLote ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8 },
                            { text: `${new Date(medicamento?.dataExpiracao).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' },
                            { text: `${medicamento?.localCompra ?? ''}`, margin: [0, 3, 0, 0], fontSize: 8, alignment: 'center' }
                        ]) ?? []
                    ],
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // POR FAVOR INDICAR
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'POR FAVOR INDICAR',
                                fontSize: 8,
                                bold: true,
                                alignment: 'center',
                                margin: [0, 2, 0, 1],
                                border: [true, false, true, false]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['25%', '25%', '25%', '25%'],
                    body: [
                        [
                            { text: `[ ${dados?.automedicacao === true ? 'X' : ''} ] Automedicação`, fontSize: 7, margin: [3, 0.5, 0, 0], border: [true, false, false, true] },
                            { text: `[ ${dados?.farmacodependencia === true ? 'X' : ''} ] Farmacodependência`, fontSize: 7, margin: [3, 0.5, 0, 0], border: [false, false, false, true] },
                            { text: `[ ${dados?.erroTerapeutico === true ? 'X' : ''} ] Erro Terapêutico`, fontSize: 7, margin: [3, 0.5, 0, 0], border: [false, false, false, true] },
                            { text: `[ ${dados?.campanhaVacinacao === true ? 'X' : ''} ] Campanha de Vacinação`, fontSize: 7, margin: [3, 0.5, 0, 0], border: [false, false, true, true] }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // EFEITOS INDESEJÁVEIS
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'EFEITOS INDESEJÁVEIS', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#97BF04',
                                margin: [0, 2, 0, 2],
                                italics: true,
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'Breve descrição do efeito indesejável',
                                fontSize: 8,
                                alignment: 'center',
                                margin: [0, 2, 0, 0.5],
                                border: [true, true, true, false],
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Linhas para descrição
            {
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: limitarTexto(`${dados?.efeitosIndesejados?.descricao}, Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`, 270), fontSize: 8, border: [true, false, true, false], margin: [0, 1, 0, 0] }],
                    ]
                },
                layout: {
                    hLineWidth: (i) => (i === 0 || i === 2) ? 1 : 0,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: `Prazo de manifestação: Hora: ${new Date(dados?.efeitosIndesejados?.inicioManifestacao).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })} Dia: ${new Date(dados?.efeitosIndesejados?.inicioManifestacao).getDate()} Mês: ${new Date(dados?.efeitosIndesejados?.inicioManifestacao).getMonth() + 1} Ano: ${new Date(dados?.efeitosIndesejados?.inicioManifestacao).getFullYear()} á dia ${new Date(dados?.efeitosIndesejados?.fimManifestacao).getDate()} Mês: ${new Date(dados?.efeitosIndesejados?.fimManifestacao).getMonth() + 1} Ano: ${new Date(dados?.efeitosIndesejados?.fimManifestacao).getFullYear()}`,
                                fontSize: 8,
                                margin: [3, 3, 0, 0],
                                border: [true, false, true, false],
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Evolução dos efeitos indesejáveis
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'Evolução dos efeitos indesejáveis',
                                fontSize: 7,
                                alignment: 'center',
                                bold: true,
                                margin: [0, 2, 0, 2],
                                border: [true, true, true, false],
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Checkboxes evolução
            {
                table: {
                    widths: ['*', '*', '*', '*'],
                    body: [
                        [
                            {
                                stack: [
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.riscoVida === true ? 'X' : ''} ] Risco de vida`, fontSize: 7, margin: [3, 2, 0, 0], },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.motivouHospitalizacao === true ? 'X' : ''}  ] Motivou hospitalização`, fontSize: 7, margin: [3, 2, 0, 0] },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.prolongouHospitalizacao === true ? 'X' : ''}  ] Prolongou hospitalização`, fontSize: 7, margin: [3, 2, 0, 0] }
                                ],
                                border: [true, false, false, false],
                            },
                            {
                                stack: [
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.malformacaoCongenita === true ? 'X' : ''}  ] Malformação congénita`, fontSize: 7, margin: [3, 2, 0, 0] },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.naoRecuperouAind === true ? 'X' : ''}  ] Não recuperou ainda`, fontSize: 7, margin: [3, 2, 0, 0] },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.recuperouSemSequelas === true ? 'X' : ''}  ] Recuperou sem sequelas`, fontSize: 7, margin: [3, 2, 0, 0] }
                                ],
                                border: [false, false, false, false],
                            },
                            {
                                stack: [
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.desconhecido === true ? 'X' : ''} ] Desconhecido`, fontSize: 7, margin: [3, 2, 0, 0] },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.recuperouComSequelas === true ? 'X' : ''} ] Recuperou com sequelas`, fontSize: 7, margin: [3, 2, 0, 0] },
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.morte === true ? 'X' : ''} ] Morte`, fontSize: 7, margin: [3, 2, 0, 0] },
                                ],
                                border: [false, false, false, false],
                            },
                            {
                                stack: [
                                    { text: `[ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.tratamentoCorrector === true ? 'X' : ''} ] Tratamento corrector`, fontSize: 7, margin: [3, 2, 0, 0] },
                                ],
                                border: [false, false, true, false],
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Suspendeu o medicamento
            {
                table: {
                    widths: ['65%', '35%'],
                    body: [
                        [
                            {
                                text: `Suspendeu o medicamento?  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.suspendeuMedicamento === true ? 'X' : ''} ]Sim  [${dados?.efeitosIndesejados?.evolucaoEfeitos?.suspendeuMedicamento === false ? 'X' : ''} ]Não`,
                                fontSize: 7,
                                margin: [3, 3, 0, 3]
                            },
                            {
                                text: `Diminui a dose do medicamento? [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.diminuiuDoseMedicamento === true ? 'X' : ''} ]Sim  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.diminuiuDoseMedicamento === false ? 'X' : ''} ]Não`,
                                fontSize: 7,
                                margin: [3, 3, 0, 3]
                            }
                        ]
                    ],
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Reintrodução do medicamento
            {
                table: {
                    widths: ['65%', '35%'],
                    body: [
                        [
                            {
                                text: `O efeito indesejável desapareceu ou diminuiu após a suspensão do medicamento?  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM === "Sim" ? 'X' : ''} ]Sim  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM === "Não" ? 'X' : ''} ]Não      [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM === "NaoAplica" ? 'X' : ''} ]Não se aplica`,
                                fontSize: 7,
                                margin: [3, 3, 0, 3],
                                border: [true, false, true, false],
                            },
                            {
                                text: `O efeito indesejável reapareceu após a reintrodução do medicamento?  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM === "Sim" ? 'X' : ''} ]Sim  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM === "Nao" ? 'X' : ''} ]Não  [ ${dados?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM === "NaoAplica" ? 'X' : ''} ]Não se aplica`,
                                fontSize: 7,
                                margin: [3, 3, 0, 3],
                                border: [false, false, true, false],
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            },

            // Dados relevantes do Laboratório
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        text: 'Dados relevantes do Laboratório',
                                        fontSize: 8,
                                        alignment: 'center',
                                        margin: [0, 2, 0, 5]
                                    },
                                    {
                                        text: limitarTexto(`${dados?.efeitosIndesejados?.descricao}, Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`, 145),
                                        fontSize: 8,
                                        alignment: 'left',
                                        margin: [0, 4, 0, 5]
                                    }
                                ]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 5]
            },

            // NOTIFICADOR
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: 'NOTIFICADOR', border: [false, false, false, false],
                                alignment: 'center',
                                bold: true,
                                fontSize: 10,
                                fillColor: '#97BF04',
                                margin: [0, 2, 0, 2],
                                italics: true,
                            },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    }
                },
                margin: [0, 0, 0, 0]
            },

            {
                table: {
                    widths: ['*', 100, '*', 80],
                    body: [
                        [
                            { text: 'Nome e Apelido', fontSize: 8, bold: true, alignment: 'center' },
                            { text: 'Categoria Profissional', fontSize: 8, bold: true, alignment: 'center' },
                            { text: 'Telefone/E-mail', fontSize: 8, bold: true, alignment: 'center', },
                            { text: 'Data de Notificação', fontSize: 8, bold: true, alignment: 'center', },
                        ],
                        [
                            { text: `${dados?.notificador?.nome}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${dados?.notificador?.categoriaProfissional ?? ''}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${dados?.notificador?.tel ?? ''}/${dados?.notificador?.email ?? ''}`, fontSize: 8, margin: [0, 2, 0, 0], alignment: 'center', },
                            { text: `${new Date(dados?.dataNotificacao).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`, fontSize: 8, margin: [0, 3, 0, 0], alignment: 'center', }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#000000',
                    vLineColor: () => '#000000'
                },
                margin: [0, 0, 0, 0]
            }
        ],
        footer: (currentPage, pageCount) => {
            const footerContent: any[] = [
                {
                    columns: [
                        {
                            stack: [
                                { text: 'Endereço: Rua Dr Américo Boavida nº83,1ºandar, farmacovigilancia@armed.gov.ao, 936123282 - 941078322', style: '', margin: [0, 0, 0, 0], bold: false, fontSize: 8.5, },
                                { text: 'Gerado pelo Gestor - Armed', style: '', margin: [0, 0, 0, 0], bold: true, italics: true },
                            ],
                            width: '100%',
                            alignment: 'left'
                        },

                    ],
                    fontSize: 8,
                    margin: [30, 0, 0, 0],
                }
            ];

            return footerContent;
        },
        styles: {},
        defaultStyle: {
            font: 'Roboto',
        }
    };

    pdfMake.createPdf(docDefinition).open();
};

export {
    FichaNotificacaoReacoesAdversas,
};